import styled from "styled-components";
import CloseIcon from "@mui/icons-material/Close";
import { Modal } from "@mui/material";

import { breakpoints } from "@/styles/breakpoints";

export const StyledImageViewer = styled(Modal)`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--radius-5);
`;

export const Container = styled.div`
    padding: 20px;
    margin-right: 24px;
    margin-left: 24px;
    background-color: var(--color-secondary-light);
    border-radius: var(--radius-10);

    @media ${breakpoints.xs} {
        padding: 10px;
        margin-right: 16px;
        margin-left: 16px;
    }
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    vertical-align: middle;
    background-color: var(--color-secondary-light);
    @media ${breakpoints.xs} {
        margin-bottom: 5px;
    }
`;

export const Title = styled.p`
    padding: 0;
    margin: 0;
    font-size: var(--size-18);
    font-weight: var(--weight-600);
    line-height: 25px;
    color: var(--color-primary);
`;

export const StyledCloseIcon = styled(CloseIcon)`
    font-size: var(--size-24);
    color: var(--color-secondary);
    cursor: pointer;
`;

export const Body = styled.div`
    width: 100%;
    height: calc(100% - 45px);
    text-align: center;
`;

export const StyledImage = styled.img`
    max-width: calc(100vw - 45px);
    max-height: calc(100vh - 120px);
`;
